import {Box, CircularProgress, Container, Typography} from "@mui/material";
import React from "react";
import HeaderWithBackButton from "../components/Common/HeaderWithBackButton.tsx";
import QueryListCard from "../components/Query/QueryListCard.tsx";
import Api from "../Interceptor/Api/index.ts";
import {Query} from "../Types/index.ts";

export default function QueryList() {
    const [isLoading, setIsLoading] = React.useState(false);
    const [queries, setQueries] = React.useState<Query[]>([]);
    const fetchAllQueries = async () => {
        setIsLoading(true);
        try {
            const response = await Api.appointment.getAllQueries();
            setQueries(response);
        } catch (error) {
            console.error("Error fetching queries:", error);
        } finally {
            setIsLoading(false);
        }
    };
    React.useEffect(() => {
        fetchAllQueries();
    }, []);
    if (isLoading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <CircularProgress/>
            </Box>
        );
    }
    return (
        <Box
            className="form-container-v1"
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: "0px",
            }}
        >
            <Box display="flex" width="100%" flexDirection="column">
                <HeaderWithBackButton title="My Queries"/>
                {queries.length === 0 ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                padding: "24px",
                            }}
                        >
                            {/* Illustration or Icon */}
                            <img
                                src="/images/no_queries.png"
                                alt="No Appointments"
                                style={{
                                    width: "240px",
                                    height: "auto",
                                }}
                            />

                            <Typography
                                variant="bodyMedium"
                                className="body-medium"
                                sx={{
                                    textAlign: "center",
                                    maxWidth: "280px",
                                    marginBottom: "24px",
                                }}
                            >
                                Feel free to reach out to us for any queries or concerns. We are here to help you!
                            </Typography>
                        </Box>
                    ) :
                    (queries.map((query: Query, index: number) => (
                        <div
                            key={index}
                            style={{
                                marginBottom: "10px",
                                marginLeft: "16px",
                                marginRight: "16px",
                            }}
                        >
                            <QueryListCard data={query}/>
                        </div>
                    )))}
            </Box>
        </Box>
    );
}
